<template>
  <div class="login-invest-wrapper">
    <div class=" main-invest-container-wrapper ">
      <router-link to="/" class="logo" />
      <div class="main-invest-container">
        <h1 class="enter-title">Инвестиции</h1>
        <h5 class="enter-sub-title">Откройте мир фондовых рынков <br>по-новому: как, куда и зачем вложить свои
          средства.
        </h5>
        <template v-if="step === 1">
          <div class="enter-caption" v-if="isMail">Вход в почту</div>
          <div class="enter-caption" v-else>
            <p>Вход / </p>
            <p>регистрация </p>
          </div>

          <div id="payment-form"></div>
          <form class="enter-form" autocomplete="_off">
            <div class="input-containers" :class="{
              'input-containers-error': error,
              'input-containers-error-agreement': error && error.type === 'agreement',
            }">
              <label for="phone">Ваш телефон</label>
              <div class="input-group">
                <input type="tel" v-model="phone" placeholder="+7 999 123 45 67" v-mask="'+7 ### ### ## ##'" id="phone"
                  class="text-input" :class="{ 'text-input-error': error.message }">
              </div>
              <div class="input-group button-group">
                <ButtonAction class="main-action-btn" type="submit" :message="error.message"
                  @buttonAction="handleSubmit" />
              </div>
              <div class="_bottom" v-if="isMail"><span style="cursor: pointer;" @click="$router.push('/')">Вернуться на
                  главную</span></div>
              <div class="_bottom" v-else><span style="cursor: pointer;" @click="$router.push('/')">Вернуться назад</span>
              </div>
            </div>
          </form>
        </template>

        <template v-if="step === 2">
          <form method="post" class="enter-form" autocomplete="off">
            <div class="input-containers" :class="{ 'input-containers-error': error }">
              <div class="input-group" style="display: block;">
                <div class="relative mt-30px">
                  <input type="password" placeholder="Пароль" v-model="password" class="text-input"
                    :class="{ 'text-input-error': error.message }">
                </div>
                <div class="relative mt-30px">
                  <input type="password" placeholder="Пароль еще раз" v-model="passwordConfirm" class="text-input"
                    :class="{ 'text-input-error': error.message }">
                </div>
              </div>
              <div class="input-group button-group">
                <ButtonAction class="main-action-btn" type="submit" :message="error.message || 'Зарегистрироваться'"
                  @buttonAction="handleSubmit" />
              </div>
            </div>
          </form>
          <div class="_bottom"><span style="cursor: pointer;" @click.prevent="step = 1">Вернуться назад</span></div>
        </template>

        <template v-if="step === 3">
          <div class="enter-caption">Вход /
          </div>
          <div id="payment-form"></div>
          <form class="enter-form" method="post" autocomplete="_off">
            <div class="input-containers" :class="{
              'input-containers-error': error
            }">
              <label for="phone"> Введите пароль для входа</label>
              <div class="input-group">
                <InputHideShow @setPass="setPass" :hasError="error" />
              </div>
              <div class="input-group button-group">
                <ButtonAction class="main-action-btn" type="submit" :message="error.message || 'Войти'"
                  @buttonAction="handleSubmit" />
              </div>
              <div class="_bottom"><span style="cursor: pointer;" @click.prevent="step = 4">Забыл пароль</span></div>
            </div>
          </form>
        </template>

        <template v-if="step === 4">
          <div class="enter-caption">Восстановление доступа /</div>
          <form method="post" class="enter-form" autocomplete="off">
            <div class="input-containers" :class="{ 'input-containers-error': error }">
              <label for="phone"> Код из SMS</label>
              <div class="input-group">
                <input type="text" placeholder="Введите код из SMS" v-model="code" v-mask="'####'" key="code"
                  class="text-input" :class="{ 'text-input-error': error.message }">
              </div>
              <div class="input-group button-group">
                <ButtonAction class="main-action-btn" :class="{ 'main-action-btn-disabled': codeSubmitDisabled }"
                  type="submit" :message="codeSubmitButton" :isDisabled="codeSubmitDisabled" @buttonAction="sendCode"
                  v-show="code.length !== 4" />
                <ButtonAction class="main-action-btn" type="submit" :message="error.message" @buttonAction="handleSubmit"
                  v-show="code.length === 4" />
              </div>
            </div>
          </form>
        </template>

        <template v-if="step === 5">
          <div class="enter-caption">Восстановление доступа /</div>
          <form method="post" class="enter-form" autocomplete="off">
            <div class="input-containers confirm" :class="{ 'input-containers-error': error }">
              <label for="phone">
                <span v-if="error && password !== passwordConfirm">Пароли не совпадают</span>
                <span v-else-if="error && (password.length < 6 || passwordConfirm.length < 6)">Пароль не менее 6
                  символов</span>
                <span v-else>Задайте новый пароль не менее 6 символов</span></label>
              <div class="input-group-double">
                <InputHideShow @setPass="setPass" :hasError="error" />
              </div>
              <div class="input-group-double">
                <InputHideShow @setPass="setPassConfirm" :hasError="error" />
              </div>

              <div class="input-group button-group">
                <input type="submit" :value="error.message || 'Войти'" class="button blue"
                  :class="{ 'btn-error': error.message }" @click.prevent="handleSubmit">
              </div>
              <div class="_bottom"><span style="cursor: pointer;" @click.prevent="step = 3">Вернуться назад</span></div>

            </div>
          </form>
        </template>
      </div>
      <div class="footer-wrapper">
        <FooterAgreement @setAgree="isAgree" />
        <div class="notpersonal-advice">
          *Любые сведения, указанные в Статьях, носят исключительно рекомендательный характер и нацелены на оказание
          помощи Пользователям Сервиса в получении необходимой справочной информации. Администрация Сервиса не несет
          ответственности за убыток или ущерб, включая, в частности, любую утрату выгоды, которая может являться прямым
          или косвенным результатом использования или принятия во внимание такой информации. Не является индивидуальной
          инвестиционной рекомендацией.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/api/axios';
import eventsBus from '@/api/events';
import FooterAgreement from '@/components/newRedesign/UI/FooterAgreement.vue';
import InputHideShow from "@/components/newRedesign/UI/InputHideShow";
import ButtonAction from "@/components/newRedesign/UI/ButtonAction";


export default {
  data: () => {
    return {
      showPassword: false,
      showPasswordConfirm: false,
      phone: '',
      password: '',
      passwordConfirm: '',
      code: '',
      step: 1,
      error: false,
      time: 30,
      seconds: 30,
      agreement: true,
      codeSubmitDisabled: true
    }
  },
  components: {
    FooterAgreement,
    InputHideShow,
    ButtonAction
  },
  computed: {
    buttonLabel() {
      return (this.showPassword) ? "Hide" : "Show";
    },

    isMail() {
      return this.$route.meta.mail;
    },
    codeSubmitButton: function () {
      if (this.time === 0) return 'Отправить еще раз';
      return 'Отправить еще раз 0:' + (this.time > 9 ? this.time : '0' + this.time);
    }
  },
  watch: {
    phone: function () {
      this.error = false;
    },
    password: function () {
      this.error = false;
    },
    passwordConfirm: function () {
      this.error = false;
    },
    code: function () {
      this.error = false;
    },
    step: function (newStep, oldStep) {
      if (newStep === 4 && oldStep !== 4) {
        this.sendCode();
      }
    }
  },
  mounted() {
    eventsBus.$emit('page-ready');

    if (this.$route.params) {
      if (this.$route.params.step && this.$route.params.phone) {
        this.step = this.$route.params.step;
        this.phone = this.$route.params.phone;
      }
    }

    let hash = window.location.hash;
    if (hash) {
      if (hash.indexOf('phone')) {
        this.step = 3;
        this.phone = decodeURI(hash.replace('#phone=', ''));
      }
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShowConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },


    async handleSubmit() {
      let phone = this.phone.replace(/\s|\(|\)|-/g, '');
      const backUrl = this.$route.params.backUrl || this.$route.query.backUrl || null;

      if (this.step === 1) {

        if (phone.length !== 12) {
          if (phone.length === 0) {
            this.error = { message: 'Введите номер телефона' };
            return false;
          }
          this.error = { message: 'Номер указан неверно' };
          return false;
        }

        if (!this.agreement) {
          this.error = {
            message: 'Примите соглашение',
            type: 'agreement'
          };
          return false;
        }

        const checkUser = (await request({ action: 'check_user', options: { phone } })).data; // todo: change req

        if (checkUser.status === false) {
          this.$router.push({
            name: 'promo-invest',
            params: {
              activateTele2: true,
              phone
            }
          });
          return false;
        } else {
          this.step = 3;
          return false;
        }
      }

      if (this.step === 2 || this.step === 5) {
        if (!this.password) {
          this.error = { message: 'Введите пароль' };
          return false;
        }
        if (!this.passwordConfirm) {
          this.error = { message: 'Подтвердите пароль' };
          return false;
        }
        if (this.password !== this.passwordConfirm) {
          this.error = { message: 'Попробовать еще раз' };
          return false;
        }
        if (this.password.length < 6 || this.passwordConfirm.length < 6) {
          this.error = { message: 'Попробовать еще раз' };
          return false;
        }

        let response = null;
        if (this.step === 2) {
          response = await request({
            action: 'register',
            options: {
              phone,
              password: this.password
            }
          });
        }

        if (this.step === 5) {
          response = await request({
            action: 'change_password',
            options: {
              phone,
              password: this.password
            }
          });
        }

        if (response?.data?.status === true) {
          this.$store.commit('login', response.data.user);
          this.$store.commit('loginInv', response.data.user_inv);
          if (this.isMail) {
            const mailLink = (await request({ action: 'get_link_to_mail' })).data;
            if (mailLink.link) {
              window.location.href = mailLink.link;
            } else {
              this.$router.push('/profile');
            }
          } else {
            if (backUrl != null) {
              this.$router.push(backUrl);
            } else {
              this.$router.push('/profile');
            }
          }
        }
        return false;
      }

      if (this.step === 3) {
        if (this.password.length === 0) {
          this.error = { message: 'Введите пароль' };
          return false;
        }

        const login = (await request({ action: 'login', options: { phone, password: this.password } })).data;

        if (login.status === false) {
          this.error = { message: 'Неверный пароль' };
          return false;
        }

        this.$store.commit('login', login.user);
        this.$store.commit('loginInv', login.user_inv);

        if (login.user_inv?.payment?.type === 1) {
          if (backUrl != null) {
            this.$router.push(backUrl);
          } else {
            this.$router.push('/investments');
          }
        } else {
          this.$router.push({
            name: 'promo-invest',
            params: {
              activateTele2: true,
              phone
            }
          });
        }
        return false;
      }

      if (this.step === 4) {
        let isCodeValid = (await request({ action: 'reset_password', options: { phone, code: this.code } })).data;

        if (isCodeValid.status === false) {
          this.error = { message: 'Код неверный' };
          return false;
        }
        this.step = 5;
        return false;
      }
    },
    async sendCode() {
      this.startTimer();
      let phone = this.phone.replace(/\s|\(|\)|-/g, '');
      return await request({ action: 'reset_password', options: { phone } });
    },
    startTimer() {
      this.time = this.seconds;
      this.codeSubmitDisabled = true;
      let interval = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(interval);
          this.codeSubmitDisabled = false;
        }
      }, 1000);
    },
    isAgree(agree) {
      this.agreement = agree
    },
    setPass(pass) {
      this.password = pass
    },
    setPassConfirm(pass) {
      this.passwordConfirm = pass
    },
  }
}
</script>

<style>
.login-invest-wrapper {
  background-image: url('../../../../assets/img/bg_login-invest.webp');
  background-position: right 0;
  background-size: 45%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 0;
  overflow-x: hidden;
}

@media screen and (max-width: 650px) {
  .login-invest-wrapper {
    background-color: #f6f6f6;
    background-image: url('../../../../assets/img/bg_login-invest_mob.webp');
    background-position: right 135px;
    background-size: 70%;
    background-repeat: no-repeat;
    height: 100%;
    /* height: -webkit-fill-available; */
  }
}

.main-invest-container-wrapper {
  padding: 126px 16px 26px;
  margin: 0 auto;
  max-width: 860px;
  position: relative;
  flex: 1 0 auto;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  display: flex;

}

.main-invest-container-wrapper .logo {
  position: absolute;
  top: 20px;
  background-image: url('../../../../assets/img/login-logo.svg');
  width: 116px;
  height: 36px;
  display: block;
}

/*@media screen and (max-width: 1300px) {*/
@media screen and (max-width: 1000px) {
  .main-invest-container-wrapper {
    padding-top: 47px;
  }
}

@media screen and (max-width: 650px) {

  /* измененно */
  .main-invest-container-wrapper {
    max-width: 288px;
    padding-top: 90px;
    padding-left: 0;
    padding-right: 0;
    min-height: 100vh;
    /* min-height: -webkit-fill-available; */
  }

}
</style>

<style scoped>
.main-invest-container {
  flex: 1 0 auto;
}

/* изменнено */
.enter-caption {
  max-width: 420px;
  margin-bottom: 18px;
  color: #000;
  font-family: 'Gilroy';
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;

}

.enter-title {
  max-width: 395px;
  margin-bottom: 10px;
  color: #333333;
  font-family: 'Gilroy';
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
}

.enter-sub-title {
  max-width: 414px;
  margin-bottom: 51px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #828282;
}

.input-containers label {
  display: block;
  margin-bottom: 0;
  font-family: Circe;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
}

.input-containers {
  max-width: 250px;
}

.input-group {
  margin-bottom: 24px;
}

.text-input {
  position: relative;
  width: 100%;
  padding: 14px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #22B491;
  outline: none;
  background-color: transparent;
  font-family: Gilroy;
  font-style: normal;
  font-size: 16px;
  line-height: 19px;
}

.confirm .text-input {
  margin-bottom: 14px;
}

.text-input:focus::-webkit-input-placeholder {
  color: transparent;
}

.text-input:focus::-moz-placeholder {
  color: transparent;
}

.text-input:focus:-moz-placeholder {
  color: transparent;
}

.text-input-error {
  border-color: #CF2F38;
}

.text-input::-webkit-input-placeholder {
  color: #bdbdbd;
}

.text-input:-moz-placeholder {
  color: #bdbdbd;
  opacity: 1;
}

.text-input::-moz-placeholder {
  color: #bdbdbd;
  opacity: 1;
}

.text-input:-ms-input-placeholder {
  color: #bdbdbd;
}

.text-input::-ms-input-placeholder {
  color: #bdbdbd;
}

.text-input::placeholder {
  color: #bdbdbd;
}

input[type="submit"] {
  cursor: pointer;
  display: block;
  width: 100%;
  max-width: 250px;
  outline: none;
  background: #22B491;
  border-radius: 8px;
  border: none;
  color: #fff;
  padding: 14px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

input.btn-error {
  background-color: #BDBDBD;
}

.notpersonal-advice {
  width: 100%;
  text-align: center;
  font-family: 'Circe';
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 16px;
  color: #828282;
}

.footer-wrapper {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

._bottom {
  text-align: center;
}

@media screen and (max-width: 650px) {
  ._bottom {
    text-align: center;
  }
}

._bottom span {
  font-family: Gilroy;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #828282;
  text-decoration: underline;
}

._bottom span:hover {
  text-decoration: none;
}

.input-group-double {
  margin-bottom: 14px;
}

@media screen and (max-width: 650px) {
  .main-invest-container-wrapper {
    width: 100%;
  }

  .enter-title {
    margin-bottom: 9px;
    font-size: 32px;
    line-height: 38px;
  }

  .enter-sub-title {
    max-width: 260px;
    margin-bottom: 30px;
    font-size: 13px;
    line-height: 15px;
  }

  .enter-caption {
    width: 123px;
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    max-width: 134px;
    margin-bottom: 14px;
    padding-top: 60px;
  }

  .enter-caption>p:last-child {
    text-align: end;
  }

  .input-containers {
    max-width: 100%;
  }

  .input-containers label {
    font-weight: 350;
    font-size: 10px;
  }

  .input-group {
    margin-bottom: 18px;
  }



  .button-group {
    margin-bottom: 22px;
  }

  .text-input {
    font-size: 16px;
    line-height: 16px;
  }

  input[type="submit"] {
    max-width: 100%;
  }

  .notpersonal-advice {
    width: 100%;
    font-size: 8px;
    line-height: 11px;
  }
}
</style>
